import PageHeader from '../PageHeader';
import Button from '../common/Button';

interface EmailManagerTopBarProps {
  onDownloadCsv: () => void;
}

const EmailManagerTopBar = ({ onDownloadCsv }: EmailManagerTopBarProps) => (
  <PageHeader title="EMAILS">
    <Button className="page-header__action-button" onClick={onDownloadCsv}>
      DOWNLOAD CSV
    </Button>
  </PageHeader>
);

export default EmailManagerTopBar;
